import { createContext, useContext, useState, useEffect } from "react";

const SelectionContext = createContext(null);
const KEY = "emporium_selection";

export const SelectionProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY)) || [];
      const seen = new Set();
      return raw.filter((i) => i && i.id && !seen.has(i.id) && seen.add(i.id));
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const has = (id) => items.some((i) => i.id === id);
  const toggle = (p) =>
    setItems((prev) =>
      prev.some((i) => i.id === p.id)
        ? prev.filter((i) => i.id !== p.id)
        : [...prev, { id: p.id, name: p.name, range: p.range }]
    );
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  return (
    <SelectionContext.Provider value={{ items, has, toggle, remove, clear }}>
      {children}
    </SelectionContext.Provider>
  );
};

export const useSelection = () => useContext(SelectionContext);
